$(() => {
  $('.cookie-modal .close, .cookie-modal .ok-btn, .cookie-modal .cancel-btn').on('click', () => {
    $('.cookie-modal').hide();
  });
});
